/**
 * Styled Components - Created by david on 10/04/18.
 */
import styled from 'styled-components'
import Search from 'antd/lib/auto-complete'
import Button from 'antd/lib/button'
import InputComponent from 'antd/lib/input'
import { BLUE, GRAY, GRAY_DARK, GRAY_LIGHT, GREEN, RED, WHITE, WHITE_SMOKE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
   background-color: #222;
 `

export const Text = styled.div`
   color: #fff;
 `

export const Title = styled.div`
   color: #5f6062;
   font-size: 18px;
   font-weight: 600;
   line-height: 25px;
 `

export const List = styled.div`
   padding-top: 22px;
   min-height: 128px;
   overflow: auto;
   white-space: nowrap;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
   width: 100%;
   align-items: flex-start;
 
   @media (min-width: 320px) and (max-width: 480px) {
     height: auto;
   }
 `

export const ErrorContainer = styled.div`
   display: flex;
   flex: 1;
   height: 60vh;
   justify-content: center;
   align-items: center;
   flex-direction: column;
 `

export const ErrorTitle = styled.div`
   color: #5f6062;
   font-size: 16px;
   font-weight: 600;
   line-height: 22px;
 `

export const Message = styled.div`
   margin-top: 16px;
   font-size: 16px;
   line-height: 23px;
   text-align: center;
 `

export const modalStyle = { paddingBottom: '96px' }

export const bodyStyle = { padding: '12px' }

export const PaginationRow = styled.div`
   text-align: right;
   padding-right: 2%;
   margin-top: 10px;
 
   @media (min-width: 320px) and (max-width: 480px) {
     padding: 0;
     text-align: center;
   }
 `

export const NotFound = styled.div`
   font-size: 18px;
 `

export const StyledSearch = styled(Search)`
   width: 100%;
   .ant-select-selection__rendered {
     line-height: 50px !important;
   }
 `

export const Input = styled(InputComponent)`
   border-radius: 0;
   margin-top: 6px;
 `

export const SearchButton = styled(Button)`
   height: 100%;
   border: none;
   width: 35px;
 `

export const TopSection = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
 `

export const SelectAllDiv = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   margin-right: 6px;
   margin-left: 18px;
   height: 50px;
   min-width: 50px;
 `

export const SelectAllLabel = styled.div`
   white-space: nowrap;
   padding: 11px 12px;
   border: 1px solid ${RED};
   border-radius: 3px;
   color: ${RED};
   font-size: 12px;
   transition: all .25s;
   &:hover {
     cursor: pointer;
     background: ${RED};
     color: ${WHITE};
   }
 `

export const TopLabels = styled.div`
  display: flex;
  align-items: center;
`

export const AdviseLabel = styled.div`
  margin-right: 30px;
  font-size: 12px;
`

export const TotalAmountsIcon = styled(Icon)`
  margin-right: 10px;
  color: ${RED};
`

export const TotalAmounts = styled.div`
  margin-right: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 10px;
`

export const ActionButtons = styled.div`
  display: inline-flex;
  margin-right: 42px;
`

export const AddButton = styled.div`
  color: #fff;
  background-color: #e61737;
  border-color: #e61737;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  width: fit-content;
  padding: 8px 14px;
  border-radius: 5px;
  margin-left: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CancelButton = styled.div`
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border: 1px solid #d9d9d9;
  width: fit-content;
  padding: 8px 12px;
  border-radius: 5px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const ProTitle = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`

export const ProCertification = styled.div`
  font-weight: bold;
  font-family: Avenir;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`

export const ProCertifyIconModal = styled.img`
  max-width: 200px;
  border-radius: 25px;
  width: 100%;
  margin-bottom: 8px;
`

export const ProCertificationSub = styled.div`
  font-weight: bold;
  font-family: Avenir;
`

export const GetYourDesigns = styled.div`
  margin-top: 6px;
  margin-bottom: 12px;
  font-family: Avenir;
`

export const ProOptional = styled.div`
  font-style: italic;
  font-size: 12px;
`

export const PlanSelection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 12px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

interface DivProps {
  admin?: boolean
  secondary?: Boolean
}

export const PlanDiv = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 366px;
  box-shadow: 0px 2px 7px 0px #bdbdbd;
  padding: 14px 28px;
  border-radius: 5px;
  position: relative;
  transition: all .3s;
  margin-right: 32px;
  min-height: 556px;
  border: ${({ secondary }: DivProps) => secondary ? `1px solid ${BLUE}` : ''};
  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 9px -1px #7f7f7f;
    transform: scale(1.007);
  }
  &:last-child {
    margin-right: 0px;
  }
  @media (max-width: 1024px) {
    margin-right: 0px;
  }
  @media (max-width: 768px) {
    margin-bottom: 28px;
    max-width: 378px;
    min-height: unset;
  }
`

export const MostPopular = styled.div`
  position: absolute;
  top: -12px;
  padding: 2px 8px;
  border-radius: 5px;
  background: #a2df84;
  color: #292929;
  font-size: 12px;
`

export const PlanTitle = styled.div`
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 20px;
  font-family: Avenir;
`

export const PriceDiv = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 12px;
  font-style: italic;
`

export const PriceValue = styled.div`
  font-size: 24px;
  margin-left: 26px;
  font-style: normal;
  font-weight: bold;
  font-family: Avenir;
  margin-right: 6px;
`

export const PlanDescription = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  font-size: 12px;
  margin-top: 20px;
`

export const DescriptionEntry = styled.div`
  margin-bottom: 10px;
`

export const CheckIcon = styled(Icon)`
  margin-right: 8px;
  color: ${GREEN};
`

export const PlanImages = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  flex: 1;
  justify-content: center;
`

export const PlanPicture = styled.img`
  max-width: 138px;
`

export const PlanImage = styled.img`
  max-width: 57px;
  margin-top: 16px;
  margin-bottom: 21px;
  @media (max-width: 698px) {
    max-width: 50px;
  }
`

export const PlanDetails = styled.ul`
  padding-left: 23px;
  font-size: 12px;
  background: #fffaec;
  padding-top: 10px;
  padding-bottom: 12px;
  padding-right: 18px;
  border-radius: 3px;
  li {
    margin-bottom: 8px;
  }
`

export const BottomActions = styled.div`
  display: flex;
  align-items: flex-end;
`

export const EmptyCircle = styled.div`
  height: 18px
  width: 18px;
  border: 2px solid ${GRAY};
  border-radius: 25px;
  margin-top: 10px;
  transition: all .25s;
  &:hover {
    color: ${BLUE};
  }
`

export const SelectButton = styled(Icon)`
  font-size: 18px;
  margin-top: 10px;
  color: ${BLUE};
`

export const BottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px;
  margin-bottom: 0;
  margin-top: 32px;
  align-items: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`

interface ButtonWrapperProps {
  disabled: boolean
}

export const InfoPrint = styled.div`
  color: ${BLUE};
  text-decoration: underline;
  transition: all .25s;
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (max-width: 698px) {
    margin-bottom: 24px;
  }
`

export const RightButtons = styled.div`
  display: flex;
`

export const GoBack = styled(Button)`
  box-shadow: 0px 1px 3px -1px silver;
  margin-right: 50px;
  background: #fafafa;
  @media (max-width: 462px) {
    margin-right: 20px;
  }
`

export const ButtonModal = styled.div`
 i {
  font-size: 11px;
  margin-left: 4px;
 }
 @media (max-width: 698px) {
   white-space: pre-wrap;
 }
`

export const NoThanks = styled(Button)`
  box-shadow: 0px 1px 4px -1px silver;
`

export const ContinueButton = styled(Button)`
  margin-left: 20px;
  box-shadow: 0px 1px 3px 0px silver;
  color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? GRAY_LIGHT : WHITE};
  background-color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? WHITE_SMOKE : BLUE};
  border-color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? WHITE_SMOKE : BLUE};

  &:hover {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
`

export const InfoSection = styled.div`
  display: flex;
  margin-bottom: 28px;
  @media (max-width: 698px) {
    flex-flow: column;
    align-items: center;
  }
`

export const DescriptionSection = styled.div`
  margin-left: 32px;
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 20px;
  }
`

export const InfoImage = styled.img`
  max-width: 220px;
  border-radius: 3px;
`

export const InfoSub = styled.div`
  font-size: 14px;
  font-family: Avenir;
`

export const SmallInfo = styled.div`
  font-size: 11px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  font-family: Avenir;
  margin-bottom: 18px;
`

export const GoodReasons = styled.div`
  font-weight: bold;
  font-family: Avenir;
  margin: 12px 0;
`

export const ReasonsList = styled.div`
  font-size: 14px;
  font-family: Avenir;
  ul {
    padding-left: 18px;
  }
  li {
    margin-bottom: 8px;
  }
`

export const EditContent = styled.div`
  margin: 22px 0 28px -38px;
  text-align: center;
`

export const TitleEdit = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
`

export const PackageIcon = styled.img`
  max-width: 30px;
  margin-top: 7px;
`

export const ImageDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DaysAmount = styled.div`
  position: absolute;
  font-weight: bold;
  color: black;
  font-size: 16px;
`
export const cancelButtonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}

export const ModalTitleDisabled = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const IconPrint = styled(Icon)`
  margin-right: 12px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CheckoutPrintCheckModal/styledComponents.tsx